export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ItemsPerPage.vue?vue&type=template&id=3cb0b9bc&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-datatable/datatable-components/ItemsPerPage.vue?vue&type=template&id=3cb0b9bc&scoped=true
// module id = xaab
// module chunks = 41